import React from "react";
import Card from "components/card";

const DepartmentCard = ({
    recordData,
    selected = false,
    onClick,
}) => {
    const Icon = recordData.icon;
    
    return (
        <Card className="opacity-100 transform-none">
            <div 
                onClick={onClick}
                className={`bg-white text-slate-900 flex flex-col gap-6 rounded-xl cursor-pointer border-2 transition-all duration-300 hover:shadow-lg h-full dark-mode-card ${
                    selected
                        ? "!border-emerald-500 shadow-lg shadow-emerald-500/20"
                        : "!border-slate-200 hover:!border-emerald-300"
                }`}
            >
                <div className="pb-6 p-3">
                    <div className={`p-2 rounded-lg ${recordData?.bgColor} mb-2 w-fit`}>
                        <Icon className={`w-5 h-5 ${recordData?.iconColor}`} />
                    </div>
                    <h3 className="text-[11px] font-semibold mb-1 line-clamp-2 title-text">
                        {recordData?.department}
                    </h3>
                    {recordData?.count > 0 && (
                        <span className="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden text-[9px] px-1.5 py-0 tracking-wide muted-text">
                            {recordData?.count} message{recordData?.count !== 1 ? "s" : ""}
                        </span>
                    )}
                </div>
            </div>
        </Card>
    )
};
export default DepartmentCard; 